/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Top_RightInputs */

const en_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Events to the top right of the video`)
};

const fr_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner les evenements en haut a droite de la video`)
};

const de_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionieren Sie die Ereignisse oben rechts im Video.`)
};

const it_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiziona gli eventi in alto a destra del video`)
};

const ru_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разместите события в правом верхнем углу видео.`)
};

const es_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colocar eventos en la parte superior derecha del vídeo`)
};

const zh_cn2_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频右上角的位置事件`)
};

const ja_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをビデオの右上に配置する`)
};

const hi_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो के ऊपरी दाएं कोने में इवेंट्स को रखें।`)
};

const pt_pt2_shortcut_keys_desc_cc_position_top_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posicione os eventos no canto superior direito do vídeo.`)
};

/**
* | output |
* | --- |
* | "Position Events to the top right of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Top_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_top_right = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Top_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cc_position_top_right(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cc_position_top_right(inputs)
	return en_shortcut_keys_desc_cc_position_top_right(inputs)
});